export default {
  "content": "<path d=\"M5.5 16l.625-2.5H3l.375-1.5H6.5l.875-3.5H4L4.375 7H7.75l.75-3H10l-.75 3h3L13 4h1.5l-.75 3H17l-.375 1.5h-3.25L12.5 12H16l-.375 1.5h-3.5L11.5 16H10l.625-2.5h-3L7 16H5.5zM8 12h3l.875-3.5h-3L8 12z\" fill=\"#656A81\"/>",
  "attrs": {
    "width": "20",
    "height": "20",
    "viewBox": "0 0 20 20",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};